export default{
    metrySet: {
      enterSetName: "Ingrese el nombre del conjunto (no se permiten caracteres especiales que no sean ' ', '-' y '_')",
      setName: "Escoger un Nombre",
      ok: 'OK',
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Borrar",
      createSetFromFilter: 'Crear Conjunto de Filtro',
      createSetFromIds: 'Crear Conjunto de Elementos Seleccionados',
      createSetFromfileUpload: 'Crear conjunto de archivo seleccionado',
      deleteSet: 'Eliminar Conjunto',
      addSelectedToSet: 'Añadir Elementos Seleccionados para Establecer',
      removeSelectedFromSet: 'Eliminar Elementos Seleccionados del Conjunto',
      setCreateError: "Error inesperado al crear el conjunto",
      setDeleteError: "Error inesperado al eliminar el conjunto",
      setUpdateError: "Error inesperado al actualizar el conjunto",
      getSetsError: "Error inesperado recuperando conjuntos",
      confirmDelete: "Confirmar eliminación",
      confirmRemove: "Confirmar Eliminar",
      confirmRemoveFromSet: "¿Está seguro de que desea eliminar {count} elementos del conjunto '{name}'?",
      confirmRemoveFromSetOne: "¿Está seguro de que desea eliminar 1 elemento del conjunto '{name}'?",
      confirmDeleteSet: "¿Estás seguro de que deseas eliminar el conjunto '{name}'?",
      duplicateSetName: "El nombre del conjunto '{nombre}' ya existe, elija otro nombre",
      setNameIsRequired: "El nombre del conjunto es obligatorio",
      invalidSetName: 'Nombre de conjunto no válido',
      setInvalidFile: 'Archivo inválido cargado',
      isLoading: 'Obteniendo datos establecidos ...',
      noData: 'Sin conjuntos',
      csvFile: 'Archivo CSV para crear un conjunto',
      csvRadioKey: 'Tipo de archivo CSV',
      radioId: 'Identificadores de radio',
      meterId: 'Identificadores de meter',
    }
}